exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".metadata-category[data-v-e8599cd0]{cursor:pointer;border-bottom:1px solid #fff}.metadata-category.active[data-v-e8599cd0],.metadata-category[data-v-e8599cd0]:hover{background-color:#eff2f7}.metadata-category .chevron-right[data-v-e8599cd0]{float:right;display:none}.metadata-category.active .chevron-right[data-v-e8599cd0]{display:block;position:relative;top:1px}", ""]);

// exports
